import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Tooltip } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/menuService";

import DataTableBloc from "../Blocs/DataTableBloc";
import apiResponse from "../../../../../services/apiResponse";

import moment from "moment";

class TableActiveComponent extends Component {
  userdata = JSON.parse(localStorage.getItem("userdata"));
  is_eselon =
    typeof this.userdata.echelon_code === "string" &&
    (this.userdata.echelon_code.startsWith("1") ||
      this.userdata.echelon_code.startsWith("2"))
      ? 1
      : 0;

  dataTableBloc = new DataTableBloc();

  source;
  historyMonth = "skp_history_month_tunsus"; //
  historyYear = "skp_history_year_tunsus"; //
  historyTable = "historySkpBaruTableActive"; // Nama di tiap tabel harus beda karena akan disimpan di session
  defaultOrder = "upload_skp_detail_id"; // orderBy
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      createUuid: null,
      updateUuid: null,
      previewUuid: null,
      inactiveUuid: null,
      activeUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      runType: null,
      confirmInfo: "Apakah anda yakin akan melakukan verifikasi tunkin?",
      roleId: localStorage.getItem("currentRoleId"),
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
      detailUuid: null,
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });
  dateParse = (input) => {
    let res = "";
    if (input !== "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };
  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    localStorage.setItem(
      this.historyMonth,
      JSON.stringify(this.props.additionalFilter.month)
    );

    localStorage.setItem(
      this.historyYear,
      JSON.stringify(this.props.additionalFilter.year)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      roleId: this.state.roleId,
      is_echelon: this.is_eselon,
      ...this.props.additionalFilter,
    };
    await this.dataTableBloc.fetchRowTable(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  deleteConfirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirmDelete: false,
          deleteUuid: null
        };
        break;
      case "confirm":
        forState = {
          loadingDelete: true,
          confirmDelete: false,
        };
        this.dataTableBloc.fetchDelete({ uuid: this.state.deleteUuid });
        break;
      case "success":
        forState = {
          successDelete: false,
          deleteUuid: null
        };
        this.setTokenAPI(); // Refresh table
        break;
      case "failed":
        forState = {
          failedDelete: false,
          deleteUuid: null
        };
        break;
      default:
        break;
    }
    this.setState(forState);
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
      confirmDelete: false,
      loadingDelete: false,
      successDelete: false,
      failedDelete: false,
      deleteUuid: null,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
      confirmDelete: false,
      loadingDelete: false,
      successDelete: false,
      failedDelete: false,
      deleteUuid: null,
        };
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };
  activeData = async () => {
    await this.dataTableBloc.fetchActive({ uuid: this.state.activeUuid });
  };

  handleButtonExport = () => {
    // alert('ooooooooooooooo')
    this.dataTableBloc.fetchExport({
      month: this.props.additionalFilter.month,
      year: this.props.additionalFilter.year,
    });
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.rowtableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          this.props.setDocument(response?.document);
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

        this.dataTableBloc.deleteChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loadingDelete: true,
          });
          break;
        case apiResponse.COMPLETED:
          this.setState({
            loadingDelete: false,
            successDelete: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loadingDelete: false,
            failedDelete: true,
          });
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.exportChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          window.open(link.file_url, "_blank");
          //window.location.href = link.file_url
          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          break;
        case apiResponse.ERROR:
          this.setState({
            urlFileDetail: link,
            loading: false,
            failed: true,
          });
          setTimeout(function () {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel?.unsubscribe();
    this.dataTableBloc.exportChannel?.unsubscribe();
  }

  columns = [
    {
      key: "upload_skp_detail_nama",
      text: "Pegawai",
      sortable: true,
      cell: (record) => {
        return (
          <span>
            <strong>{record.upload_skp_detail_nip}</strong>
            <br></br>
            {record.upload_skp_detail_nama}
            <br></br>
            {record.upload_skp_detail_skp_jabatan ? (
              <>
                {
                  record.upload_skp_detail_skp_jabatan
                }
              </>
            ) : (
              <>
                <span style={{ color: "red" }}>
                  {record.upload_skp_detail_skp_jabatan}
                </span>
              </>
            )}
            <br></br>
          </span>
        );
      },
    },
    {
      key: "upload_skp_detail_skp_hasil_kerja",
      text: "Hasil Kerja",
      sortable: true,
      cell: "-",
    },
    {
      key: "upload_skp_detail_skp_perilaku_kerja",
      text: "Perilaku Kerja",
      sortable: true,
      cell: "-",
    },

    {
      key: "upload_skp_detail_skp_hasil_akhir",
      text: "Hasil Akhir",
      sortable: true,
      cell: "-",
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 120,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.upload_skp_detail_id;
        let status = record.upload_skp_detail_status;
        return (
          <Fragment>
            <span>
              <button
                className="btn btn-primary btn-sm"
                id={"detail-" + thisId}
                onClick={() => {
                  this.setState({
                    detailUuid: record.upload_skp_detail_uuid,
                  });
                }}
                style={{
                  marginRight: "2px",
                  padding: "2px 5px",
                }}
              >
                <i className="uil-align-left"></i>
              </button>
              <Tooltip
                style={{
                  marginBottom: 2,
                }}
                placement="top"
                isOpen={this.state["detail" + thisId]}
                target={"detail-" + thisId}
                toggle={() => {
                  this.setState({
                    ["detail" + thisId]: !this.state["detail" + thisId],
                  });
                }}
              >
                Detil
              </Tooltip>

              <button
                className="btn btn-danger btn-sm"
                id={"delete-" + thisId}
                onClick={() => {
                  this.setState({
                    deleteUuid: record.upload_skp_detail_uuid,
                    confirmDelete: true
                  });
                }}
                style={{
                  marginRight: "2px",
                  padding: "2px 5px",
                }}
              >
                <i className="uil-trash-alt"></i>
              </button>
              <Tooltip
                style={{
                  marginBottom: 2,
                }}
                placement="top"
                isOpen={this.state["deleteTooltip" + thisId]}
                target={"delete-" + thisId}
                toggle={() => {
                  this.setState({
                    ["deleteTooltip" + thisId]: !this.state["deleteTooltip" + thisId],
                  });
                }}
              >
                Hapus
              </Tooltip>
            </span>
          </Fragment>
        );
      },
    },
  ];
  render() {
    return (
      <>
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
                <ConfirmAlert
          confirmTitle="Konfirmasi Hapus!"
          confirmInfo={`Apakah anda yakin akan menghapus data ini?`}
          loadingTitle="Menghapus data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil dihapus"
          failedTitle="Gagal!"
          failedInfo="Data gagal dihapus"
          showConfirm={this.state.confirmDelete}
          showLoading={this.state.loadingDelete}
          showSuccess={this.state.successDelete}
          showFailed={this.state.failedDelete}
          response={this.deleteConfirmResponse}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo={`Apakah anda yakin akan mengubah status data ini?`}
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil diubah"
          failedTitle="Gagal!"
          failedInfo="Data gagal diubah"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
       
        {this.state.detailUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/skp.html?detail&uuid=" +
              this.state.detailUuid
            }
          />
        ) : null}
      </>
    );
  }
}

export default TableActiveComponent;
